import { NeedItem, NeedStatus, NeedType, VestaBorrowerCondition } from "pages/dashboard/home/dashboardService";

export const VESTA_LOS_TYPE = "vesta";

const KNOWN_VESTA_NEED_STATUSES = new Set<string>([
  NeedStatus.PendingDocuments.toLowerCase(),
  NeedStatus.ReviewNeeded.toLowerCase(),
  NeedStatus.Satisfied.toLowerCase(),
]);

export type VestaConditionsPathInput = {
  readonly losType?: string;
  readonly vestaConditionsEnabled?: boolean;
  readonly loanKey?: string;
  readonly vestaBorrowerId?: string;
};

/** True when session loan is Vesta — Encompass Needs List must not be called. */
export const isVestaLoanSession = (losType?: string): boolean => losType === VESTA_LOS_TYPE;

/**
 * When true, Tasks should call BFF vesta-conditions (flag on + both ids present).
 * Missing ids or flag off → empty Tasks, no Needs fallback (ADO-548030).
 */
export const shouldFetchVestaConditions = (input: VestaConditionsPathInput): boolean =>
  isVestaLoanSession(input.losType) &&
  input.vestaConditionsEnabled === true &&
  Boolean(input.loanKey?.trim()) &&
  Boolean(input.vestaBorrowerId?.trim());

const resolveNeedStatus = (raw?: string | null): NeedStatus | undefined => {
  if (!raw?.trim()) {
    return undefined;
  }

  const normalized = raw.trim().toLowerCase();
  if (!KNOWN_VESTA_NEED_STATUSES.has(normalized)) {
    return undefined;
  }

  if (normalized === NeedStatus.ReviewNeeded.toLowerCase()) {
    return NeedStatus.ReviewNeeded;
  }

  if (normalized === NeedStatus.Satisfied.toLowerCase()) {
    return NeedStatus.Satisfied;
  }

  return NeedStatus.PendingDocuments;
};

export const mapVestaConditionsToNeedItems = (
  conditions: VestaBorrowerCondition[] | undefined,
): NeedItem[] => {
  if (!conditions?.length) {
    return [];
  }

  return conditions.flatMap((condition) => {
    const needStatus = resolveNeedStatus(condition.needStatus);
    if (!needStatus) {
      return [];
    }

    return [
      {
        id: condition.id,
        title: condition.title,
        note: condition.note ?? undefined,
        needStatus,
        needType: NeedType.VestaConditions,
      },
    ];
  });
};
